<template>
<div id="Noticias">
    <h1>Noticias</h1><br>
        <!-- inicio sección de noticias -->
        <div  class="seccion-noticias">
            <article class="news-info">
                <div class="news-header">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/vj9OZ7t9AO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    <!--<h2 class="news-info__title">Noticia 1</h2>-->
                </div>
                <p class="news-info__text">
                    Maravilloso Video de niños sobre el cambio climático.
                </p>
            </article>



        <article class="news-info">
                <div class="news-header">
                    <!--<img class="news-info__imagen" src="http://placeimg.com/400/200/tech" alt="">
                    <h2 class="news-info__title">Noticia 2</h2>-->
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/bsCOQoo4vqQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <p class="news-info__text">
                    Efectos generados por el cambio climático.
                </p>
            </article>

            <article class="news-info">
                <div class="news-header">
                    <!--<img class="news-info__imagen" src="http://placeimg.com/400/200/arch" alt="">
                    <h2 class="news-info__title">Noticia 3</h2>-->
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/Ezuu7NuIDfI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <p class="news-info__text">
                    Tutorial Resolución 1407 de 2018 del Ministerio del Medio Ambiente
                </p>
            </article>

            <article class="news-info">
                <div class="news-header">
                    <!--<img class="news-info__imagen" src="http://placeimg.com/400/200/people" alt="">
                    <h2 class="news-info__title">Noticia 4</h2>-->
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/wNQ5wvGmnEk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <p class="news-info__text">
                    26 Formas de Luchar contra el Cambio Climático.
                </p>
            </article>

        </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>